import React, { Component } from "react";
import { connect } from "react-redux";
import classes from './RefundList.css'
import RefundHistoryTable from "./RefundHistoryTable/RefundHistoryTable";
import Arrow from '../../../assets/Arrow.svg';
import desc from '../../../assets/descIcon.svg';
import ace from '../../../assets/aceIcon.svg';
import close from '../../../assets/close.svg';
import { RequestForRefundList } from "../../../store/action/index";
import RefundStatus from "./RefundHistoryTable/RefundStatus/RefundStatus";

class RefundList extends Component {

    state = {
        pagination: [" "],
        currentPage: 0,
        DescsortType: true,
        status: -1,
        pagesize: 10,
        showDelete: false
    }

    componentDidMount = () => {
        this.props.RequestForRefundList();
    }

    componentWillReceiveProps = (props) => {
        if (props.refundList)
            this.setState({
                pagination: Array(props.refundList.TotalPages).fill(" "),
            })
    }

    OnPginationClick = value => {
        this.setState({
            currentPage: --value,
        }, () => {
            this.props.RequestForRefundList(this.state.currentPage, this.state.DescsortType, this.state.status, this.state.pagesize)
        })
    }

    OnArrowClick = (param) => {
        if (param === 'Inc') {
            this.setState(prevState => {
                return {
                    currentPage: prevState.currentPage + 1
                }
            }, () => {
                this.props.RequestForRefundList(this.state.currentPage, this.state.DescsortType, this.state.status, this.state.pagesize)
            });
        } else {
            this.setState(prevState => {
                return {
                    currentPage: prevState.currentPage - 1
                }
            }, () => {
                this.props.RequestForRefundList(this.state.currentPage, this.state.DescsortType, this.state.status, this.state.pagesize)
            })
        }
    }

    OnFilterChage = () => {
        this.setState(prevState => {
            return {
                DescsortType: !prevState.DescsortType,
                showDelete: true,
            }
        }, () => {
            this.props.RequestForRefundList(this.state.currentPage, this.state.DescsortType, this.state.status, this.state.pagesize);
        })
    }

    onStatusFilter = (status) => {
        this.setState({
            status: status,
            showDelete: true,
        }, () => {
            this.props.RequestForRefundList(0, this.state.DescsortType, this.state.status, this.state.pagesize);
        })
    }

    onPageSizeChage = (event) => {
        this.setState({
            pagesize: event.target.value,
            showDelete: true,
        }, () => {
            this.props.RequestForRefundList(0, this.state.DescsortType, this.state.status, this.state.pagesize);
        })
    }

    onRemoveFilter = () => {
        this.setState({
            pagination: [" "],
            currentPage: 0,
            DescsortType: true,
            status: -1,
            pagesize: 10,
            showDelete: false
        }, () => {
            this.props.RequestForRefundList(0, true, -1, 10);
        })
    }

    render() {
        let paginationlength= this.state.pagination.length;
        return (
            <div>
                <RefundStatus StatusFilter={this.onStatusFilter} />
                <div className={classes.filterFuther}>
                    <p
                        onClick={this.OnFilterChage}
                        className={classes.filterIcon}>مرتب سازی بر اساس تاریخ
                        {
                            this.state.DescsortType
                                ? <span><img src={desc} alt="آیکون فیلتر" /></span>
                                : <span><img src={ace} alt="آیکون فیلتر" /></span>
                        }
                    </p>
                    <p className={classes.filterIcon}>تعداد نتایج
                        <select
                            value={this.state.pagesize}
                            onChange={this.onPageSizeChage}>
                            <option value="10">10</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                        </select>
                    </p>
                    {
                        this.state.showDelete
                            ? <p
                                onClick={this.onRemoveFilter}
                                className={classes.RemovefilterIcon}>
                                حذف تمام فیلتر ها
                                <span>
                                    <img src={close} alt="آیکون فیلتر" />
                                </span>
                            </p>
                            : null
                    }
                </div>
                <div className={classes.tableBox}>
                    <RefundHistoryTable />
                </div>
                <div className={classes.nvigationButton}>
                    {
                        this.props.refundList
                            ? this.state.pagination.length > 3
                                ? this.state.currentPage === 0
                                    ? <span>
                                        <img src={Arrow} className={[classes.ArrowStyle, classes.Deactive].join(" ")} alt="Arrow Icons" />
                                    </span>
                                    : <span>
                                        <img onClick={() => this.OnArrowClick("Dec")} src={Arrow} className={classes.ArrowStyle} alt="Arrow Icons" />
                                    </span>
                                : null
                            : null
                    }
                    {
                        this.props.refundList
                            ? this.state.pagination.map((_, i) => {
                                return this.state.currentPage === i
                                    ? <p key={i} className={classes.PageActive}>{++i}</p>
                                    : <p key={i} onClick={() => this.OnPginationClick(i)}>{++i}</p>
                            })
                            : null
                    }
                    {
                        this.props.refundList
                            ? this.state.pagination.length > 3
                                ? this.state.currentPage === --paginationlength
                                    ? <span>
                                        <img src={Arrow} className={[classes.ArrowStyle, classes.LArrow, classes.Deactive].join(" ")} alt="Arrow Icons" />
                                    </span>
                                    : <span>
                                        <img onClick={() => this.OnArrowClick("Inc")} src={Arrow} className={[classes.ArrowStyle, classes.LArrow].join(" ")} alt="Arrow Icons" />
                                    </span>
                                : null
                            : null
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        refundList: state.REFUND.refundList
    }
}

const mapDispatchToProps = dispatch => {
    return {
        RequestForRefundList: (page, Sort, status, pagesize) => dispatch(RequestForRefundList(page, Sort, status, pagesize))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RefundList)